<template>
  <div
    class="common-switch"
    @click="handlerToggleSwitch"
    :class="{ notSure: !value }"
  >
    <span :class="{ 'is-on': +value === +on }"></span>
  </div>
</template>

<script>
export default {
  name: 'commonSwitch',
  components: {},
  props: {
    value: {
      type: [Boolean, String, Number],
      default: false
    },
    on: {
      type: [Boolean, String, Number],
      default: true
    },
    off: {
      type: [Boolean, String, Number],
      default: false
    }
  },
  data() {
    return {
      date: ''
    }
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    handlerToggleSwitch() {
      let _val = this.value === this.on ? this.off : this.on
      this.$emit('input', _val)
    }
  },
  filters: {}
}
</script>

<style lang="scss" scoped>
.common-switch {
  width: 50px;
  height: 30px;
  border: 1px solid #006afe;
  border-radius: 40px;
  background: #006afe;
  position: relative;
  > span {
    display: inline-block;
    position: absolute;
    border: 1px solid #006afe;
    width: 27px;
    height: 27px;
    background: #ffffff;
    border-radius: 50%;
    &.is-on {
      left: 22px;
      transition: all 0.2s ease-in;
    }
  }
}

.notSure {
  background: rgba(120, 120, 128, 0.16);
  border: 2px solid #e5e5ee;
  > span {
    left: -1px;
    height: 27px;
    border: 1px solid #e5e5ee;
    transition: all 0.2s ease-out;
  }
}
</style>
